var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { PortalBootstrapService } from '../services/portal-bootstrap.service';
import { Auth0ClientService } from '../services/auth0-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/authentication.service";
import * as i2 from "@angular/router";
import * as i3 from "../services/portal-bootstrap.service";
import * as i4 from "../services/auth0-client.service";
export class AuthenticationGuard {
    constructor(authService, router, portalBootstrap, auth0Client) {
        this.authService = authService;
        this.router = router;
        this.portalBootstrap = portalBootstrap;
        this.auth0Client = auth0Client;
    }
    canActivate(route, state) {
        const url = `${state.url}`;
        const teamId = route.parent.paramMap.get('team');
        const redirectUrl = teamId ? `/${teamId}` : '/';
        return this.loadAuthenticationChecker(url, redirectUrl, teamId);
    }
    canActivateChild(childRoute, state) {
        return this.canActivate(childRoute, state);
    }
    canLoad(route, segments) {
        const actualUrl = '/' + segments.map(s => s.path).join('/');
        const teamCodePath = segments[0].path;
        const redirectUrl = teamCodePath ? `/${teamCodePath}` : `/`;
        return this.loadAuthenticationChecker(actualUrl, redirectUrl, teamCodePath);
    }
    loadAuthenticationChecker(url, redirectUrl, teamCodePath) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.portalBootstrap.auth0Enabled) {
                const isAuthenticated = yield this.auth0Client.isAuthenticated();
                if (isAuthenticated) {
                    return true;
                }
                this.router.navigate([redirectUrl], { queryParams: { returnUrl: url } });
                return false;
            }
            if (this.authService.isLoggedInPortal(teamCodePath)) {
                return true;
            }
            // Preserve the original URL as returnUrl query parameter
            this.router.navigate([redirectUrl], { queryParams: { returnUrl: url } });
            return false;
        });
    }
}
AuthenticationGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticationGuard_Factory() { return new AuthenticationGuard(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.PortalBootstrapService), i0.ɵɵinject(i4.Auth0ClientService)); }, token: AuthenticationGuard, providedIn: "root" });
